module.exports = __webpack_public_path__ + "img/Tessellate40.b6db8258.jpg";